import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom'; 
import { FormattedMessage } from 'react-intl'; 
import ItemCategoriaGrid from './ItemCategoriaGrid';
import ItemCategoriaAbm from './ItemCategoriaAbm';
import ConfigBusiness from '../../commons/config/ConfigBusiness';

const ItemCategoria = ({ match }) => { 

  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage
              id="item_categoria.header_administracion_de_categorias"
              defaultMessage="Administración de Categorias"
            />
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          <Route exact path={`${match.url}`} render={(props) => <ItemCategoriaGrid {...props}  />} />
          <Route exact path={`${match.url}/add`} render={props => <ItemCategoriaAbm {...props} action="ADD"  />} />
          <Route exact path={`${match.url}/:id`} render={props => <ItemCategoriaAbm {...props} action="VIEW" />} />
          <Route exact path={`${match.url}/:id/edit`} render={props => <ItemCategoriaAbm {...props} action="EDIT" />} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(ItemCategoria);